import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
//import Button from '@material-ui/core/Button';
import {compose} from 'recompose'
//import Typography from '@material-ui/core/Typography';
import { subscribeToTopic } from '../../../actions/subscriptions'

// matirial-ui imports
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Switch from '@material-ui/core/Switch';
import NotificationIcon from '@material-ui/icons/NotificationImportant';
import Card from '@material-ui/core/Card'

const styles = theme => ({
    paper: {
        padding: theme.spacing.unit*2,
        marginBottom: theme.spacing.unit
      },
      card: {
          marginBottom: theme.spacing.unit
      }
  });

const SubscriptionTopic = (props) => {
    const { topic, mySubscriptions, userId, token, functions } = props
    
    const getNotificationStateColor = (isMyTopic)=> {
        if(isMyTopic) {
            return 'primary'
        } else {
            return 'disabled'
        }
    }
    // check curren Topic is my Topic - global Const
    const isMyTopic = mySubscriptions.indexOf(topic.subType) !== -1

    const handleToggleSubscription = (selectedTopic) => {
        const { mySubscriptions } = props;
        const currentIndex = mySubscriptions.indexOf(selectedTopic);
        const newMySubscriptions = [...mySubscriptions];
        if (currentIndex === -1) {
        // case switch is checked
          newMySubscriptions.push(selectedTopic);
        } else {
        // case switch unchecked
          newMySubscriptions.splice(currentIndex, 1);
        }
        const updatedMySubscriptionsState = {
            newMySubscriptions: newMySubscriptions,
            userId: userId,
            topic: selectedTopic,
            isMyTopic: isMyTopic,
            token: token
        }
        functions.onToggleSubscription(updatedMySubscriptionsState)

    }
    
    return (
        <Card className={props.classes.card}>
            <ListItem>
                <ListItemIcon>
                <NotificationIcon color={getNotificationStateColor(isMyTopic)}/>
                </ListItemIcon>
                <ListItemText primary={topic.name}/>
                <ListItemSecondaryAction>
                <Switch color='primary'
                    onChange={()=>handleToggleSubscription(topic.subType)}
                    checked={mySubscriptions.indexOf(topic.subType) !== -1}
                />
                </ListItemSecondaryAction>
            </ListItem>
        </Card>
    )

}
    
    const mapStateToProps = (state) =>({
        userId: state.sessionState.authUser.uid,
        mySubscriptions: state.subscriptionState.mySubscriptions,
        token: state.notificationState.notificationToken
    })
    
    const mapDispatchToProps = (dispatch) => ({
        functions: {
            onToggleSubscription: (subscriptionDataObj)=>subscribeToTopic(dispatch, subscriptionDataObj),
        },
      });
    
    
    
    
    SubscriptionTopic.propTypes = {
        classes: PropTypes.object.isRequired,
      }
    
    export default compose(
        connect(mapStateToProps, mapDispatchToProps),
        withStyles(styles)
    )(SubscriptionTopic)


// WEBPACK FOOTER //
// ./src/Components/UserAuth/UserAccount/SubscriptionTopic.js